
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppReviewMediaSectionList',
  props: {
    review: {
      type: Object,
      required: true
    },
    reviewIndex: { type: Number, required: true },
    popupParams: { type: Object, required: true }
  },
  computed: {
    ...mapState('window', ['windowService']),
    ...mapGetters('widget', ['reviewPopupUrl'])
  },
  methods: {
    onClickMedium(event, mediaPosition) {
      if (event.metaKey || event.ctrlKey) return;

      event.preventDefault();
      const url = this.reviewPopupUrl(
        this.review,
        mediaPosition,
        this.reviewIndex,
        this.popupParams
      );
      this.windowService.openFullscreenPopup(url, event.currentTarget);
    }
  }
};
